import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css'
import { fieldPropTypes } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import DateInput from './DateInput/DateInput';
import Input from '../Input';
import Style from '../../../styles/common';
import TimeInput from './TimeInput/TimeInput';
import moment from 'moment/moment';

const Container = styled('div')`
  margin-top: 3px; // rc-time-picker popup alignment hack
`;

const CombinedInput = styled('div')`
  display: flex;
`;

class DateTimeInput extends React.Component {
  static propTypes = {
    ...fieldPropTypes,
    label: PropTypes.string,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    label: '',
    placeholder: '',
  };

  render() {
    const { input } = this.props;

    return (
      <Container>
        <Input {...this.props}>
          <CombinedInput>
            <DateInput
              defaultDate={DateTimeInput.defaultDate}
              input={input}
            />
            <TimeInput
              defaultDate={DateTimeInput.defaultDate}
              input={input}
            />
          </CombinedInput>
        </Input>
      </Container>
    );
  }

  static get defaultDate() {
    const followingSaturday = 6;
    const noon = { 'hour': 12, 'minute': 0 };

    let date = moment().isoWeekday(followingSaturday);
    if (moment().isoWeekday() > followingSaturday) {
      date = moment().add(1, 'weeks').isoWeekday(followingSaturday);
    }

    return date.set(noon);
  }

  onFocusChange = ({ focused }) => focused ? this.props.input.onFocus() : this.props.input.onBlur();
}

export default DateTimeInput;



// WEBPACK FOOTER //
// ./src/components/Form/DateTimeInput/DateTimeInput.js